/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull frontend-user-journey'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 39
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/iwoca/Production/implementation/frontend-user-journey)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'development' | 'production';

export const ApiKey: Record<Environment, string> = {
  development: 'f6201fdf6beace4ddaf040b33936a5e3',
  production: 'c8deac245de40e642fe0dbb2bbb0d2d2'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '39',
    branch: 'main',
    source: 'frontend-user-journey',
    versionId: 'ade7731a-3750-474c-979a-025dbf18b519'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  /**
   * Business' annual profit (Sole Traders, Ordinary Partnerships and Other only)
   */
  annual_business_profit?: any;
  /**
   * Business' annual turnover, as reported by the customer
   */
  annual_turnover?: any;
  /**
   * Total number of applications that resulted in a decline
   */
  "Applications declined"?: any;
  /**
   * Total number of applications that resulted in funding
   */
  "Applications funded"?: any;
  "Applications made"?: any;
  "Applications offered"?: any;
  "Auto formal offers received"?: any;
  "Brokerage Name"?: any;
  "Browser height"?: any;
  "Browser height maximum"?: any;
  "Browser width"?: any;
  "Browser width maximum"?: any;
  "Business type"?: any;
  "Current CLTV"?: any;
  "Customer type"?: any;
  customerType?: any;
  "Decision type"?: any;
  /**
   * Auto (Willy) or manual (Credit Analyst) decision
   */
  decisionType?: any;
  "Device category"?: any;
  "Domain country"?: any;
  "Fundings made"?: any;
  impersonating?: boolean;
  impersonatorType?: any;
  industry?: any;
  "Initial CLTV"?: any;
  "Introducer referred by"?: any;
  "Introducer type"?: any;
  introducerAccount?: any;
  "Manual formal offers received"?: any;
  "Offers received"?: any;
  online_sales_percentage?: any;
  productType?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "Requested amount"?: number;
  requestedProductType?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | UK, DE |
   */
  site: "UK" | "DE";
  "Split test choice at offer stage experiment"?: string;
  "Split test UK multi product experiment"?: any;
  /**
   * List of split tests a customer is part of
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Split tests"?: string[];
  "Total amount formally offered"?: any;
  "Total amount withdrawn"?: any;
  "User type"?: any;
  /**
   * The type of user being tracked
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | customer, introducer, staff |
   */
  user_type?: "customer" | "introducer" | "staff";
  userType?: any;
  vat_registered_status?: any;
}

export interface ActivityTrackerSessionEndedProperties {
  page: string;
  profile_id: string;
  session_ended_at: string;
}

export interface ActivityTrackerSessionStartedProperties {
  page: string;
  profile_id: string;
  session_started_at: string;
}

export interface BuyerSubmittedPayNowXSellApplicationProperties {
  /**
   * Identifier returned by the backend for the current application
   */
  application_id?: string;
}

export interface BuyerSubmittedXSellApplicationProperties {
  /**
   * Identifier returned by the backend for the current application
   */
  application_id?: string;
}

export interface AdditionalGuarantorAddedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "Active step"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface AdditionalGuarantorModalOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "Active step"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface ApplicationPendingPageViewedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Required, Not required, Optional |
   */
  "Aged debtor report required": "Required" | "Not required" | "Optional";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Documents Review, Your Decision, Credit Analyst Review, Application Submitted |
   */
  application_pending_status: "Documents Review" | "Your Decision" | "Credit Analyst Review" | "Application Submitted";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Required, Not required, Optional |
   */
  "Company accounts required": "Required" | "Not required" | "Optional";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Required, Not required, Optional |
   */
  "Management accounts required": "Required" | "Not required" | "Optional";
}

export interface BusinessDetailsSubmittedProperties {
  category?: any;
  pageName?: any;
  url?: any;
}

export interface BuyerDashboardViewedProperties {
  buyer_dashboard_state: string;
}

export interface CheckYourScheduleClickedProperties {
  account_id: string;
}

export interface ClickedAntBannerProperties {
  url?: any;
}

export interface ClickedXSellBannerProperties {
  url?: any;
}

export interface CompanyTypeSelectedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Limited company, Sole Trader, Ordinary partnership, Limited liability partnership, Other |
   */
  company_type: "Limited company" | "Sole Trader" | "Ordinary partnership" | "Limited liability partnership" | "Other";
}

export interface CopyRequiredDocumentsClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface DashboardViewedProperties {
  account_id: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | ongoing, overdue, ended, unknown |
   */
  dashboard_state: "ongoing" | "overdue" | "ended" | "unknown";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | credit_facility, flexi24, business_loan, merchant_cash_advance, cbils, recovery_loan, iwocapay |
   */
  product_type:
    | "credit_facility"
    | "flexi24"
    | "business_loan"
    | "merchant_cash_advance"
    | "cbils"
    | "recovery_loan"
    | "iwocapay";
}

export interface DecisionModalViewedProperties {
  /**
   * Describes the state of the decision modal at the end of the iwocaPay signup
   */
  decision_modal_state: string;
}

export interface DisplayedAntBannerProperties {
  url?: any;
}

export interface DisplayedXSellBannerProperties {
  url?: any;
}

export interface DrawdownCompleteApplicationStepViewedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  amount: number;
  formalOfferId: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  funding_requirements: string[];
}

export interface DrawdownCompletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  amount: number;
  formalOfferId: string;
}

export interface DrawdownConfirmClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  amount: number;
  formalOfferId: string;
}

export interface DrawdownConfirmStepViewedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  amount: number;
  formalOfferId: string;
}

export interface DrawdownSignDocumentsStepViewedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  amount: number;
  formalOfferId: string;
}

export interface DrawdownStartedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  amount: number;
  formalOfferId: string;
}

export interface EarlyRepaymentCalculatorLinkClickedProperties {
  formal_offer_id: string;
}

export interface EarlyRepaymentCalculatorUsedProperties {
  early_repayment_date: string;
  preset_button: string;
}

export interface EditAmountOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  amount: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface EmailRequiredDocumentsClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface ExternalLinkClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category: string;
  "CTA destination": string;
  "CTA text"?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "CTA URL": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "Page name": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  URL: string;
}

export interface FcaRegulatedClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface FormFieldCompletedProperties {
  form_field: string;
}

export interface FormFieldStartedProperties {
  form_field: string;
}

export interface FormalOfferSelectedProperties {
  formal_offer_id: string;
}

export interface FormalisedAutoOfferGreaterThanTheRequestedAmountProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  formalised_product_keys: string[];
}

export interface HelpMethodSelectedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  CTA_type?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface HelpOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url: string;
}

export interface HomescreenBannerLinkClickedProperties {
  "Link type": string;
}

export interface IndicativeOffersViewedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url: string;
}

export interface InstantDecisionCtaClickedProperties {
  category?: any;
  pageName?: any;
  payload?: {
    requestedProductType?: {
      [k: string]: any;
    };
    suggestProductType?: {
      [k: string]: any;
    };
  };
  requestedProductType?: any;
  suggestProductType?: any;
  url?: any;
}

export interface InternalLinkClickedProperties {
  category?: string;
  "CTA destination"?: string;
  "CTA text"?: string;
  "CTA type"?: any;
  "CTA URL"?: string;
  "Page name"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  URL: string;
}

export interface LendingDecisionErroredProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "Error type"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface LogoutClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface ManualCompanyNameSelectedProperties {
  location_clicked_from: string;
}

export interface MyOffersVisitedProperties {
  application_status?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  formal_offer_ids?: string[];
  page_status?: string;
}

export interface NewDocUploadsDocumentUploadFailedProperties {
  "Document name": string;
  "Document type"?: any;
}

export interface NewDocUploadsSuccessfullyUploadedDocumentProperties {
  "Document name": string;
  "Document type"?: any;
}

export interface NewLoanDocumentsStepSubmittedProperties {
  /**
   * Identifier returned by the backend for the current application
   */
  application_id?: string;
}

export interface NewLoanDocumentsStepViewedProperties {
  application_id: string;
}

export interface NewLoanRequestCompletedProperties {
  /**
   * Identifier returned by the backend for the current application
   */
  application_id?: string;
}

export interface NewLoanRequestStartedProperties {
  account_id: string;
}

export interface OfferSelectedProperties {
  category?: any;
  decisionType?: any;
  offerType?: any;
  pageName?: any;
  requestedProductType?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  selectedOfferProduct: string;
  suggestedProduct?: any;
  url?: any;
}

export interface OffersPageViewedProperties {
  /**
   * Describes the offer ids presented to the customer
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  offer_ids: string[];
}

export interface OpenBankingConnectStartedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface OpenBankingFinishedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "Linking outcome"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface OpenBankingModalClosedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface OpenBankingModalOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface PayLinkCopiedProperties {
  url?: any;
}

export interface PayLinkLandingPageViewedProperties {
  /**
   * Iwocapay pay link ID that is being checked out on.
   */
  pay_link_id?: string;
  /**
   * Type of pay link a certain event is associated with
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | generic, custom, package, spending_limit |
   */
  pay_link_type: "generic" | "custom" | "package" | "spending_limit";
  /**
   * Indicates whether 12m product pricing is set to buyer pays or seller pays. Omitted if 12m not enabled by seller.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | buyer_pays, seller_pays |
   */
  product_pricing_12m?: "buyer_pays" | "seller_pays";
  /**
   * Indicates whether 3m pricing is set to buyer pays or seller pays
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | buyer_pays, seller_pays |
   */
  product_pricing_3m: "buyer_pays" | "seller_pays";
  /**
   * ID of the seller that the payment checkout is for
   */
  seller_id?: string;
  /**
   * Describes the payment options for a pay link visible on iwocaPay pages
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  visible_payment_options: ("pay_now" | "pay_in_3" | "pay_in_12")[];
}

export interface PaymentOptionSelectedProperties {
  /**
   * Type of pay link a certain event is associated with
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | generic, custom, package, spending_limit |
   */
  pay_link_type: "generic" | "custom" | "package" | "spending_limit";
  /**
   * Describes the selected payment option
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | pay_now, pay_in_3, pay_in_12 |
   */
  payment_option: "pay_now" | "pay_in_3" | "pay_in_12";
}

export interface PaymentOptionSubmittedProperties {
  /**
   * Type of pay link a certain event is associated with
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | generic, custom, package, spending_limit |
   */
  pay_link_type: "generic" | "custom" | "package" | "spending_limit";
  /**
   * Describes the selected payment option
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | pay_now, pay_in_3, pay_in_12 |
   */
  payment_option: "pay_now" | "pay_in_3" | "pay_in_12";
}

export interface PersonalDetailsSubmittedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url: string;
}

export interface PhoneNumberClickedProperties {
  location_clicked_from: string;
  url?: any;
}

export interface ProductOffersLoadTimeProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  duration: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | personal_information_submitted, trading_history_loaded, trading_history_submitted |
   */
  location: "personal_information_submitted" | "trading_history_loaded" | "trading_history_submitted";
}

export interface ProfileOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface ProgressBarClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  step_to?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface RepaymentScheduleViewedProperties {
  category?: any;
  "CTA source"?: any;
  "Offered amount"?: any;
  "Outstanding balance"?: any;
  pageName?: any;
  "Product type"?: any;
  "Requested amount"?: any;
  url?: any;
}

export interface RequestMoreFundsClickedProperties {
  account_id: string;
}

export interface RequestedAmountChangedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  edited_amount?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface SaveApplicationClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface SelectedCheckoutOptionProperties {
  /**
   * Iwocapay pay link ID that is being checked out on.
   */
  pay_link_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | pay_now, pay_in_3, pay_in_12 |
   */
  selected_option: "pay_now" | "pay_in_3" | "pay_in_12";
  /**
   * Describes the payment options for a pay link visible on iwocaPay pages
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  visible_payment_options: ("pay_now" | "pay_in_3" | "pay_in_12")[];
}

export interface SelectedOfferProperties {
  /**
   * id of offer related to the event
   */
  offer_id: string;
  /**
   * Describes the offer ids presented to the customer
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  offer_ids: string[];
  /**
   * Iwocapay pay link ID that is being checked out on.
   */
  pay_link_id?: string;
}

export interface ShareRequiredDocumentsClosedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface ShareRequiredDocumentsOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface SignupCompletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  decisionType?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  requestedAmount?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  requestedProduct?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  suggestedProduct?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface StepLoadedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "Step name"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface SubmittedXSellApplicationProperties {
  /**
   * Identifier returned by the backend for the current application
   */
  application_id?: string;
}

export interface SwitchedToCoreBusinessDashboardProperties {
  url?: any;
}

export interface SwitchedToIwocaPayDashboardProperties {
  url?: any;
}

export interface TopupInlineFormApplicationStepSubmittedProperties {
  application_id?: string;
}

export interface TopupInlineFormApplicationStepViewedProperties {
  application_id?: string;
}

export interface TopupInlineFormDocumentsStepSubmittedProperties {
  /**
   * Identifier returned by the backend for the current application
   */
  application_id?: string;
}

export interface TopupInlineFormDocumentsStepViewedProperties {
  /**
   * Identifier returned by the backend for the current application
   */
  application_id?: string;
}

export interface TopupReapplyFormApplicationStepSubmittedProperties {
  /**
   * Identifier returned by the backend for the current application
   */
  application_id?: string;
}

export interface TopupReapplyFormApplicationStepViewedProperties {
  /**
   * Identifier returned by the backend for the current application
   */
  application_id?: string;
}

export interface TopupReapplyFormDocumentsStepSubmittedProperties {
  /**
   * Identifier returned by the backend for the current application
   */
  application_id?: string;
}

export interface TopupReapplyFormDocumentsStepViewedProperties {
  /**
   * Identifier returned by the backend for the current application
   */
  application_id?: string;
}

export interface TopupRequestCompletedProperties {
  /**
   * Identifier returned by the backend for the current application
   */
  application_id?: string;
}

export interface TopupRequestStartedProperties {
  account_id: string;
}

export interface TradingHistorySubmittedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | v1, v2 |
   */
  "Page version": "v1" | "v2";
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url: string;
}

export interface TradingHistoryViewedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Required, Not required, Optional |
   */
  "Aged debtor report required": "Required" | "Not required" | "Optional";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Required, Not required, Optional |
   */
  "Bank statements required": "Required" | "Not required" | "Optional";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Required, Not required, Optional |
   */
  "Business plan required": "Required" | "Not required" | "Optional";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Required, Not required, Optional |
   */
  "Company accounts required": "Required" | "Not required" | "Optional";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | low_probability_of_offer, medium_probability_of_offer, high_probability_of_offer |
   */
  loan_probability?: "low_probability_of_offer" | "medium_probability_of_offer" | "high_probability_of_offer";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Required, Not required, Optional |
   */
  "Management accounts required": "Required" | "Not required" | "Optional";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | v1, v2 |
   */
  "Page version": "v1" | "v2";
  "Requested amount"?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "Requested product type": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  requested_amount: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  suggested_amount?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Required, Not required, Optional |
   */
  "VAT returns required": "Required" | "Not required" | "Optional";
}

export interface TrueLayerBankConnectStartedProperties {
  bankId?: string;
  bankName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface TrueLayerBankSelectionProperties {
  bankId: string;
  bankName: string;
}

export interface TrueLayerModalClosedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface UploadBankStatementsClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "Linking outcome"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  url?: string;
}

export interface ViewedOffersProperties {
  /**
   * Describes which iwocapay choose offer page the event was fired from.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | buyer_dashboard, landing_page, choose_product_page |
   */
  choose_offer_page: "buyer_dashboard" | "landing_page" | "choose_product_page";
  /**
   * Describes the offer ids presented to the customer
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  offer_ids: string[];
  /**
   * Iwocapay pay link ID that is being checked out on.
   */
  pay_link_id?: string;
}

export interface XeroBankStatementsLinkingFailedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "Error message"?: string;
}

export interface DrawdownPropertiesProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  amount: number;
  formalOfferId: string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ActivityTrackerSessionEnded implements BaseEvent {
  event_type = '[Activity Tracker] - session ended';

  constructor(
    public event_properties: ActivityTrackerSessionEndedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ActivityTrackerSessionStarted implements BaseEvent {
  event_type = '[Activity Tracker] - session started';

  constructor(
    public event_properties: ActivityTrackerSessionStartedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BuyerClickedPayNowXSellBanner implements BaseEvent {
  event_type = '[Buyer] Clicked pay now x-sell banner';
}

export class BuyerClickedXSellBanner implements BaseEvent {
  event_type = '[Buyer] Clicked x-sell banner';
}

export class BuyerDisplayedPayNowXSellBanner implements BaseEvent {
  event_type = '[Buyer] Displayed pay now x-sell banner';
}

export class BuyerDisplayedXSellBanner implements BaseEvent {
  event_type = '[Buyer] Displayed x-sell banner';
}

export class BuyerSubmittedPayNowXSellApplication implements BaseEvent {
  event_type = '[Buyer] Submitted pay now x-sell application';

  constructor(
    public event_properties?: BuyerSubmittedPayNowXSellApplicationProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BuyerSubmittedXSellApplication implements BaseEvent {
  event_type = '[Buyer] Submitted x-sell application';

  constructor(
    public event_properties?: BuyerSubmittedXSellApplicationProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AdditionalGuarantorAdded implements BaseEvent {
  event_type = 'Additional guarantor added';

  constructor(
    public event_properties?: AdditionalGuarantorAddedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AdditionalGuarantorModalOpened implements BaseEvent {
  event_type = 'Additional guarantor modal opened';

  constructor(
    public event_properties?: AdditionalGuarantorModalOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AgedDebtorReportUploadClicked implements BaseEvent {
  event_type = 'Aged debtor report upload clicked';
}

export class AgedDebtorReportUploaded implements BaseEvent {
  event_type = 'Aged debtor report uploaded';
}

export class ApplicationPendingPageViewed implements BaseEvent {
  event_type = 'Application pending page viewed';

  constructor(
    public event_properties: ApplicationPendingPageViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BankDetailsSubmitted implements BaseEvent {
  event_type = 'Bank details submitted';
}

export class BankStatementsUploaded implements BaseEvent {
  event_type = 'Bank statements uploaded';
}

export class BusinessDetailsSubmitted implements BaseEvent {
  event_type = 'Business details submitted';

  constructor(
    public event_properties?: BusinessDetailsSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BusinessPlanUploadClicked implements BaseEvent {
  event_type = 'Business plan upload clicked';
}

export class BusinessPlanUploaded implements BaseEvent {
  event_type = 'Business plan uploaded';
}

export class BusinessProfileSubmitted implements BaseEvent {
  event_type = 'Business profile submitted';
}

export class BuyerDashboardViewed implements BaseEvent {
  event_type = 'Buyer dashboard viewed';

  constructor(
    public event_properties: BuyerDashboardViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CheckYourScheduleClicked implements BaseEvent {
  event_type = 'Check your schedule clicked';

  constructor(
    public event_properties: CheckYourScheduleClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ClickedAntBanner implements BaseEvent {
  event_type = 'Clicked ANT banner';

  constructor(
    public event_properties?: ClickedAntBannerProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ClickedButtonToPaySeller implements BaseEvent {
  event_type = 'Clicked button to pay seller';
}

export class ClickedXSellBanner implements BaseEvent {
  event_type = 'Clicked x-sell banner';

  constructor(
    public event_properties?: ClickedXSellBannerProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CompanyAccountsUploadClicked implements BaseEvent {
  event_type = 'Company accounts upload clicked';
}

export class CompanyAccountsUploaded implements BaseEvent {
  event_type = 'Company accounts uploaded';
}

export class CompanyNameSearchSecondarySelected implements BaseEvent {
  event_type = 'Company name search secondary selected';
}

export class CompanyNameSearched implements BaseEvent {
  event_type = 'Company name searched';
}

export class CompanyTypeSelected implements BaseEvent {
  event_type = 'Company type selected';

  constructor(
    public event_properties: CompanyTypeSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CompletePaymentClicked implements BaseEvent {
  event_type = 'Complete payment clicked';
}

export class CopyRequiredDocumentsClicked implements BaseEvent {
  event_type = 'Copy required documents clicked';

  constructor(
    public event_properties?: CopyRequiredDocumentsClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DashboardViewed implements BaseEvent {
  event_type = 'Dashboard viewed';

  constructor(
    public event_properties: DashboardViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DecisionModalViewed implements BaseEvent {
  event_type = 'Decision modal viewed';

  constructor(
    public event_properties: DecisionModalViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DirectorsProfileSubmitted implements BaseEvent {
  event_type = 'Directors profile submitted';
}

export class DisplayedAntBanner implements BaseEvent {
  event_type = 'Displayed ANT banner';

  constructor(
    public event_properties?: DisplayedAntBannerProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DisplayedXSellBanner implements BaseEvent {
  event_type = 'Displayed x-sell banner';

  constructor(
    public event_properties?: DisplayedXSellBannerProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DocUploadBannerLinkClicked implements BaseEvent {
  event_type = 'Doc upload banner - link clicked';
}

export class DrawdownCompleteApplicationStepViewed implements BaseEvent {
  event_type = 'Drawdown - complete application step viewed';

  constructor(
    public event_properties: DrawdownCompleteApplicationStepViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DrawdownCompleted implements BaseEvent {
  event_type = 'Drawdown - completed';

  constructor(
    public event_properties: DrawdownCompletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DrawdownConfirmClicked implements BaseEvent {
  event_type = 'Drawdown - confirm clicked';

  constructor(
    public event_properties: DrawdownConfirmClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DrawdownConfirmStepViewed implements BaseEvent {
  event_type = 'Drawdown - confirm step viewed';

  constructor(
    public event_properties: DrawdownConfirmStepViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DrawdownMshFormOpened implements BaseEvent {
  event_type = 'Drawdown - MSH form opened';
}

export class DrawdownMshModalOpened implements BaseEvent {
  event_type = 'Drawdown - MSH modal opened';
}

export class DrawdownMshPersonAdded implements BaseEvent {
  event_type = 'Drawdown - MSH person added';
}

export class DrawdownSignDocumentsStepViewed implements BaseEvent {
  event_type = 'Drawdown - sign documents step viewed';

  constructor(
    public event_properties: DrawdownSignDocumentsStepViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DrawdownStarted implements BaseEvent {
  event_type = 'Drawdown - started';

  constructor(
    public event_properties: DrawdownStartedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EarlyRepaymentCalculatorLinkClicked implements BaseEvent {
  event_type = 'Early Repayment Calculator Link clicked';

  constructor(
    public event_properties: EarlyRepaymentCalculatorLinkClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EarlyRepaymentCalculatorUsed implements BaseEvent {
  event_type = 'Early Repayment Calculator Used';

  constructor(
    public event_properties: EarlyRepaymentCalculatorUsedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EditAmountOpened implements BaseEvent {
  event_type = 'edit amount opened';

  constructor(
    public event_properties: EditAmountOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EmailRequiredDocumentsClicked implements BaseEvent {
  event_type = 'Email required documents clicked';

  constructor(
    public event_properties?: EmailRequiredDocumentsClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ExitSecurityChecksEarly implements BaseEvent {
  event_type = 'Exit security checks early';
}

export class ExternalLinkClicked implements BaseEvent {
  event_type = 'External link clicked';

  constructor(
    public event_properties: ExternalLinkClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FcaRegulatedClicked implements BaseEvent {
  event_type = 'FCA regulated clicked';

  constructor(
    public event_properties?: FcaRegulatedClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FinishedSellerSignup implements BaseEvent {
  event_type = 'Finished seller signup';
}

export class FormFieldCompleted implements BaseEvent {
  event_type = 'Form field completed';

  constructor(
    public event_properties: FormFieldCompletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FormFieldStarted implements BaseEvent {
  event_type = 'Form field started';

  constructor(
    public event_properties: FormFieldStartedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FormalOfferSelected implements BaseEvent {
  event_type = 'Formal offer selected';

  constructor(
    public event_properties: FormalOfferSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FormalisedAutoOfferGreaterThanTheRequestedAmount implements BaseEvent {
  event_type = 'Formalised auto offer greater than the requested amount';

  constructor(
    public event_properties: FormalisedAutoOfferGreaterThanTheRequestedAmountProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class HelpMethodSelected implements BaseEvent {
  event_type = 'Help method selected';

  constructor(
    public event_properties?: HelpMethodSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class HelpOpened implements BaseEvent {
  event_type = 'Help opened';

  constructor(
    public event_properties: HelpOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class HomescreenBannerClosed implements BaseEvent {
  event_type = 'Homescreen banner - closed';
}

export class HomescreenBannerLinkClicked implements BaseEvent {
  event_type = 'Homescreen banner - link clicked';

  constructor(
    public event_properties: HomescreenBannerLinkClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class IndicativeOffersViewed implements BaseEvent {
  event_type = 'Indicative Offers viewed';

  constructor(
    public event_properties: IndicativeOffersViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InstantDecisionCtaClicked implements BaseEvent {
  event_type = 'Instant decision CTA clicked';

  constructor(
    public event_properties?: InstantDecisionCtaClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalLinkClicked implements BaseEvent {
  event_type = 'Internal link clicked';

  constructor(
    public event_properties: InternalLinkClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class LendingDecisionErrored implements BaseEvent {
  event_type = 'Lending decision errored';

  constructor(
    public event_properties?: LendingDecisionErroredProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class LinkedRepaymentCard implements BaseEvent {
  event_type = 'Linked repayment card';
}

export class LoginLinkRequested implements BaseEvent {
  event_type = 'Login link requested';
}

export class LogoutClicked implements BaseEvent {
  event_type = 'Logout clicked';

  constructor(
    public event_properties?: LogoutClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ManagementAccountsUploadClicked implements BaseEvent {
  event_type = 'Management accounts upload clicked';
}

export class ManagementAccountsUploaded implements BaseEvent {
  event_type = 'Management accounts uploaded';
}

export class ManualCompanyNameCompleted implements BaseEvent {
  event_type = 'Manual company name completed';
}

export class ManualCompanyNameSelected implements BaseEvent {
  event_type = 'Manual company name selected';

  constructor(
    public event_properties: ManualCompanyNameSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MobileLoanSummaryOpenend implements BaseEvent {
  event_type = 'Mobile loan summary openend';
}

export class MyOffersVisited implements BaseEvent {
  event_type = 'My offers visited';

  constructor(
    public event_properties?: MyOffersVisitedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewDocUploadsClickedEditAmount implements BaseEvent {
  event_type = 'New doc uploads - clicked edit amount';
}

export class NewDocUploadsClickedLinkBankAccountSection implements BaseEvent {
  event_type = 'New doc uploads - clicked link bank account section';
}

export class NewDocUploadsClickedManualBankStatementSection implements BaseEvent {
  event_type = 'New doc uploads - clicked manual bank statement section';
}

export class NewDocUploadsClickedSubmitApplication implements BaseEvent {
  event_type = 'New doc uploads - clicked submit application';
}

export class NewDocUploadsDocumentUploadFailed implements BaseEvent {
  event_type = 'New doc uploads - document upload failed';

  constructor(
    public event_properties: NewDocUploadsDocumentUploadFailedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewDocUploadsPageViewed implements BaseEvent {
  event_type = 'New doc uploads - page viewed';
}

export class NewDocUploadsRequirementsOutstanding implements BaseEvent {
  event_type = 'New doc uploads - requirements outstanding';
}

export class NewDocUploadsResolvedAllRequirements implements BaseEvent {
  event_type = 'New doc uploads - resolved all requirements';
}

export class NewDocUploadsSuccessfullyLinkedBankAccountViaTruelayer implements BaseEvent {
  event_type = 'New doc uploads - successfully linked bank account via truelayer';
}

export class NewDocUploadsSuccessfullyUploadedDocument implements BaseEvent {
  event_type = 'New doc uploads - successfully uploaded document';

  constructor(
    public event_properties: NewDocUploadsSuccessfullyUploadedDocumentProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewLoanApplicationStepSubmitted implements BaseEvent {
  event_type = 'New loan - application step submitted';
}

export class NewLoanApplicationStepViewed implements BaseEvent {
  event_type = 'New loan - application step viewed';
}

export class NewLoanDocumentsStepSubmitted implements BaseEvent {
  event_type = 'New loan - documents step submitted';

  constructor(
    public event_properties?: NewLoanDocumentsStepSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewLoanDocumentsStepViewed implements BaseEvent {
  event_type = 'New loan - documents step viewed';

  constructor(
    public event_properties: NewLoanDocumentsStepViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewLoanRequestCompleted implements BaseEvent {
  event_type = 'New loan - request completed';

  constructor(
    public event_properties?: NewLoanRequestCompletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewLoanRequestStarted implements BaseEvent {
  event_type = 'New loan - request started';

  constructor(
    public event_properties: NewLoanRequestStartedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OfferSelected implements BaseEvent {
  event_type = 'Offer selected';

  constructor(
    public event_properties: OfferSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OffersPageViewed implements BaseEvent {
  event_type = 'Offers page viewed';

  constructor(
    public event_properties: OffersPageViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OpenBankingConnectStarted implements BaseEvent {
  event_type = 'Open banking connect started';

  constructor(
    public event_properties?: OpenBankingConnectStartedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OpenBankingFinished implements BaseEvent {
  event_type = 'Open banking finished';

  constructor(
    public event_properties?: OpenBankingFinishedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OpenBankingLinkedSuccessfully implements BaseEvent {
  event_type = 'Open banking linked successfully';
}

export class OpenBankingLinkingCancelled implements BaseEvent {
  event_type = 'Open banking linking cancelled';
}

export class OpenBankingLinkingFailed implements BaseEvent {
  event_type = 'Open banking linking failed';
}

export class OpenBankingModalClosed implements BaseEvent {
  event_type = 'Open banking modal closed';

  constructor(
    public event_properties?: OpenBankingModalClosedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OpenBankingModalOpened implements BaseEvent {
  event_type = 'Open banking modal opened';

  constructor(
    public event_properties?: OpenBankingModalOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PayLinkCopied implements BaseEvent {
  event_type = 'Pay link copied';

  constructor(
    public event_properties?: PayLinkCopiedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PayLinkLandingPageViewed implements BaseEvent {
  event_type = 'Pay link landing page viewed';

  constructor(
    public event_properties: PayLinkLandingPageViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PaymentOptionSelected implements BaseEvent {
  event_type = 'Payment option selected';

  constructor(
    public event_properties: PaymentOptionSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PaymentOptionSubmitted implements BaseEvent {
  event_type = 'Payment option submitted';

  constructor(
    public event_properties: PaymentOptionSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PersonalDetailsSubmitted implements BaseEvent {
  event_type = 'Personal details submitted';

  constructor(
    public event_properties: PersonalDetailsSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PhoneNumberClicked implements BaseEvent {
  event_type = 'Phone number clicked';

  constructor(
    public event_properties: PhoneNumberClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProductOffersLoadTime implements BaseEvent {
  event_type = 'Product offers load time';

  constructor(
    public event_properties: ProductOffersLoadTimeProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProfileOpened implements BaseEvent {
  event_type = 'Profile opened';

  constructor(
    public event_properties?: ProfileOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProgressBarClicked implements BaseEvent {
  event_type = 'Progress bar clicked';

  constructor(
    public event_properties?: ProgressBarClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RefreshSpendingLimitButtonClicked implements BaseEvent {
  event_type = 'Refresh spending limit button clicked';
}

export class RepaymentCardLinked implements BaseEvent {
  event_type = 'repayment card linked';
}

export class RepaymentScheduleViewed implements BaseEvent {
  event_type = 'Repayment schedule viewed';

  constructor(
    public event_properties?: RepaymentScheduleViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RequestMoreFundsClicked implements BaseEvent {
  event_type = 'Request more funds clicked';

  constructor(
    public event_properties: RequestMoreFundsClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RequestedAmountChanged implements BaseEvent {
  event_type = 'Requested amount changed';

  constructor(
    public event_properties?: RequestedAmountChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SaveApplicationClicked implements BaseEvent {
  event_type = 'Save application clicked';

  constructor(
    public event_properties?: SaveApplicationClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SelectedCheckoutOption implements BaseEvent {
  event_type = 'Selected checkout option';

  constructor(
    public event_properties: SelectedCheckoutOptionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SelectedOffer implements BaseEvent {
  event_type = 'Selected offer';

  constructor(
    public event_properties: SelectedOfferProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SellerDocumentsUploaded implements BaseEvent {
  event_type = 'Seller documents uploaded';
}

export class SellerEmailAdded implements BaseEvent {
  event_type = 'Seller email added';
}

export class ShareRequiredDocumentsClosed implements BaseEvent {
  event_type = 'Share required documents closed';

  constructor(
    public event_properties?: ShareRequiredDocumentsClosedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ShareRequiredDocumentsOpened implements BaseEvent {
  event_type = 'Share required documents opened';

  constructor(
    public event_properties?: ShareRequiredDocumentsOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SignupCompleted implements BaseEvent {
  event_type = 'Signup completed';

  constructor(
    public event_properties?: SignupCompletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SkippedToStandardDecision implements BaseEvent {
  event_type = 'Skipped to standard decision';
}

export class SpendingLimitViewedOtherTerms implements BaseEvent {
  event_type = 'Spending limit viewed other terms';
}

export class SpillBannerClosed implements BaseEvent {
  event_type = 'Spill banner - closed';
}

export class SpillBannerLinkClicked implements BaseEvent {
  event_type = 'Spill banner - link clicked';
}

export class StartedSecurityChecksEarly implements BaseEvent {
  event_type = 'Started security checks early';
}

export class StepLoaded implements BaseEvent {
  event_type = 'Step loaded';

  constructor(
    public event_properties?: StepLoadedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SubmittedXSellApplication implements BaseEvent {
  event_type = 'Submitted x-sell application';

  constructor(
    public event_properties?: SubmittedXSellApplicationProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SwitchedToCoreBusinessDashboard implements BaseEvent {
  event_type = 'Switched to core business dashboard';

  constructor(
    public event_properties?: SwitchedToCoreBusinessDashboardProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SwitchedToIwocaPayDashboard implements BaseEvent {
  event_type = 'Switched to iwocaPay dashboard';

  constructor(
    public event_properties?: SwitchedToIwocaPayDashboardProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TopupInlineFormApplicationStepSubmitted implements BaseEvent {
  event_type = 'Topup - Inline form application step submitted';

  constructor(
    public event_properties?: TopupInlineFormApplicationStepSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TopupInlineFormApplicationStepViewed implements BaseEvent {
  event_type = 'Topup - Inline form application step viewed';

  constructor(
    public event_properties?: TopupInlineFormApplicationStepViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TopupInlineFormDocumentsStepSubmitted implements BaseEvent {
  event_type = 'Topup - Inline form documents step submitted';

  constructor(
    public event_properties?: TopupInlineFormDocumentsStepSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TopupInlineFormDocumentsStepViewed implements BaseEvent {
  event_type = 'Topup - Inline form documents step viewed';

  constructor(
    public event_properties?: TopupInlineFormDocumentsStepViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TopupReapplyFormApplicationStepSubmitted implements BaseEvent {
  event_type = 'Topup - Reapply form application step submitted';

  constructor(
    public event_properties?: TopupReapplyFormApplicationStepSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TopupReapplyFormApplicationStepViewed implements BaseEvent {
  event_type = 'Topup - Reapply form application step viewed';

  constructor(
    public event_properties?: TopupReapplyFormApplicationStepViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TopupReapplyFormDocumentsStepSubmitted implements BaseEvent {
  event_type = 'Topup - Reapply form documents step submitted';

  constructor(
    public event_properties?: TopupReapplyFormDocumentsStepSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TopupReapplyFormDocumentsStepViewed implements BaseEvent {
  event_type = 'Topup - Reapply form documents step viewed';

  constructor(
    public event_properties?: TopupReapplyFormDocumentsStepViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TopupRequestCompleted implements BaseEvent {
  event_type = 'Topup - Request completed';

  constructor(
    public event_properties?: TopupRequestCompletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TopupRequestStarted implements BaseEvent {
  event_type = 'Topup request started';

  constructor(
    public event_properties: TopupRequestStartedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TradingHistorySubmitted implements BaseEvent {
  event_type = 'Trading history submitted';

  constructor(
    public event_properties: TradingHistorySubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TradingHistoryViewed implements BaseEvent {
  event_type = 'Trading history viewed';

  constructor(
    public event_properties: TradingHistoryViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TrueLayerBankConnectStarted implements BaseEvent {
  event_type = 'TrueLayer bank connect started';

  constructor(
    public event_properties?: TrueLayerBankConnectStartedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TrueLayerBankSelection implements BaseEvent {
  event_type = 'TrueLayer bank selection';

  constructor(
    public event_properties: TrueLayerBankSelectionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TrueLayerModalClosed implements BaseEvent {
  event_type = 'TrueLayer modal closed';

  constructor(
    public event_properties?: TrueLayerModalClosedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UploadBankStatementsClicked implements BaseEvent {
  event_type = 'Upload bank statements clicked';

  constructor(
    public event_properties?: UploadBankStatementsClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class VatReturnsUploadClicked implements BaseEvent {
  event_type = 'VAT returns upload clicked';
}

export class VatReturnsUploaded implements BaseEvent {
  event_type = 'VAT returns uploaded';
}

export class ViewedOffers implements BaseEvent {
  event_type = 'Viewed offers';

  constructor(
    public event_properties: ViewedOffersProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class XeroBankStatementsConnectStarted implements BaseEvent {
  event_type = 'Xero bank statements connect started';
}

export class XeroBankStatementsLinkedSuccessfully implements BaseEvent {
  event_type = 'Xero bank statements linked successfully';
}

export class XeroBankStatementsLinkingFailed implements BaseEvent {
  event_type = 'Xero bank statements linking failed';

  constructor(
    public event_properties?: XeroBankStatementsLinkingFailedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class XeroBankStatementsModalOpened implements BaseEvent {
  event_type = 'Xero bank statements modal opened';
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * [Activity Tracker] - session ended
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/%5BActivity%20Tracker%5D%20-%20session%20ended)
   *
   * This event tracks the end of a page session in Eden
   *
   * Owner: Adam Flynn
   *
   * @param properties The event's properties (e.g. page)
   * @param options Amplitude event options.
   */
  activityTrackerSessionEnded(
    properties: ActivityTrackerSessionEndedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ActivityTrackerSessionEnded(properties), options);
  }

  /**
   * [Activity Tracker] - session started
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/%5BActivity%20Tracker%5D%20-%20session%20started)
   *
   * This event tracks the start of the time spent on a given page in Eden.
   *
   * Owner: Adam Flynn
   *
   * @param properties The event's properties (e.g. page)
   * @param options Amplitude event options.
   */
  activityTrackerSessionStarted(
    properties: ActivityTrackerSessionStartedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ActivityTrackerSessionStarted(properties), options);
  }

  /**
   * [Buyer] Clicked pay now x-sell banner
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/%5BBuyer%5D%20Clicked%20pay%20now%20x-sell%20banner)
   *
   * Clicked on the banner for cross-selling the core-business product from iwocaPay pay-now flow.
   *
   * @param options Amplitude event options.
   */
  buyerClickedPayNowXSellBanner(
    options?: EventOptions,
  ) {
    return this.track(new BuyerClickedPayNowXSellBanner(), options);
  }

  /**
   * [Buyer] Clicked x-sell banner
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/%5BBuyer%5D%20Clicked%20x-sell%20banner)
   *
   * Clicked on the banner for cross-selling the core-business product from iwocaPay.
   *
   * @param options Amplitude event options.
   */
  buyerClickedXSellBanner(
    options?: EventOptions,
  ) {
    return this.track(new BuyerClickedXSellBanner(), options);
  }

  /**
   * [Buyer] Displayed pay now x-sell banner
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/%5BBuyer%5D%20Displayed%20pay%20now%20x-sell%20banner)
   *
   * Showed banner for cross-selling the core-business product from iwocaPay pay-now flow.
   *
   * @param options Amplitude event options.
   */
  buyerDisplayedPayNowXSellBanner(
    options?: EventOptions,
  ) {
    return this.track(new BuyerDisplayedPayNowXSellBanner(), options);
  }

  /**
   * [Buyer] Displayed x-sell banner
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/%5BBuyer%5D%20Displayed%20x-sell%20banner)
   *
   * Showed banner for cross-selling the core-business product from iwocaPay.
   *
   * @param options Amplitude event options.
   */
  buyerDisplayedXSellBanner(
    options?: EventOptions,
  ) {
    return this.track(new BuyerDisplayedXSellBanner(), options);
  }

  /**
   * [Buyer] Submitted pay now x-sell application
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/%5BBuyer%5D%20Submitted%20pay%20now%20x-sell%20application)
   *
   * This event tracks when a buyer submits an application for cross-selling the core-business product from the iwocaPay pay-now flow.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  buyerSubmittedPayNowXSellApplication(
    properties?: BuyerSubmittedPayNowXSellApplicationProperties,
    options?: EventOptions,
  ) {
    return this.track(new BuyerSubmittedPayNowXSellApplication(properties), options);
  }

  /**
   * [Buyer] Submitted x-sell application
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/%5BBuyer%5D%20Submitted%20x-sell%20application)
   *
   * This event tracks when a buyer submits an application for cross-selling the core-business product from iwocaPay.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  buyerSubmittedXSellApplication(
    properties?: BuyerSubmittedXSellApplicationProperties,
    options?: EventOptions,
  ) {
    return this.track(new BuyerSubmittedXSellApplication(properties), options);
  }

  /**
   * Additional guarantor added
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Additional%20guarantor%20added)
   *
   * Owner: Emma Haines
   *
   * @param properties The event's properties (e.g. Active step)
   * @param options Amplitude event options.
   */
  additionalGuarantorAdded(
    properties?: AdditionalGuarantorAddedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AdditionalGuarantorAdded(properties), options);
  }

  /**
   * Additional guarantor modal opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Additional%20guarantor%20modal%20opened)
   *
   * Owner: Emma Haines
   *
   * @param properties The event's properties (e.g. Active step)
   * @param options Amplitude event options.
   */
  additionalGuarantorModalOpened(
    properties?: AdditionalGuarantorModalOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AdditionalGuarantorModalOpened(properties), options);
  }

  /**
   * Aged debtor report upload clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Aged%20debtor%20report%20upload%20clicked)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param options Amplitude event options.
   */
  agedDebtorReportUploadClicked(
    options?: EventOptions,
  ) {
    return this.track(new AgedDebtorReportUploadClicked(), options);
  }

  /**
   * Aged debtor report uploaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Aged%20debtor%20report%20uploaded)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param options Amplitude event options.
   */
  agedDebtorReportUploaded(
    options?: EventOptions,
  ) {
    return this.track(new AgedDebtorReportUploaded(), options);
  }

  /**
   * Application pending page viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Application%20pending%20page%20viewed)
   *
   * This event tracks when a user views the application pending page, which is displayed when their application is being processed and awaiting approval
   *
   * @param properties The event's properties (e.g. Aged debtor report required)
   * @param options Amplitude event options.
   */
  applicationPendingPageViewed(
    properties: ApplicationPendingPageViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationPendingPageViewed(properties), options);
  }

  /**
   * Bank details submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Bank%20details%20submitted)
   *
   * Submitted bank details as part of the iwocaPay seller account activation.
   *
   * @param options Amplitude event options.
   */
  bankDetailsSubmitted(
    options?: EventOptions,
  ) {
    return this.track(new BankDetailsSubmitted(), options);
  }

  /**
   * Bank statements uploaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Bank%20statements%20uploaded)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param options Amplitude event options.
   */
  bankStatementsUploaded(
    options?: EventOptions,
  ) {
    return this.track(new BankStatementsUploaded(), options);
  }

  /**
   * Business details submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Business%20details%20submitted)
   *
   * This event tracks when a user submits their business details during the sign-up process
   *
   * Owner: Emma Haines
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  businessDetailsSubmitted(
    properties?: BusinessDetailsSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new BusinessDetailsSubmitted(properties), options);
  }

  /**
   * Business plan upload clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Business%20plan%20upload%20clicked)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param options Amplitude event options.
   */
  businessPlanUploadClicked(
    options?: EventOptions,
  ) {
    return this.track(new BusinessPlanUploadClicked(), options);
  }

  /**
   * Business plan uploaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Business%20plan%20uploaded)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param options Amplitude event options.
   */
  businessPlanUploaded(
    options?: EventOptions,
  ) {
    return this.track(new BusinessPlanUploaded(), options);
  }

  /**
   * Business profile submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Business%20profile%20submitted)
   *
   * Submitted business profile as part of the iwocaPay seller account activation.
   *
   * @param options Amplitude event options.
   */
  businessProfileSubmitted(
    options?: EventOptions,
  ) {
    return this.track(new BusinessProfileSubmitted(), options);
  }

  /**
   * Buyer dashboard viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Buyer%20dashboard%20viewed)
   *
   * Tracks when a buyer sees their dashboard
   *
   * @param properties The event's properties (e.g. buyer_dashboard_state)
   * @param options Amplitude event options.
   */
  buyerDashboardViewed(
    properties: BuyerDashboardViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new BuyerDashboardViewed(properties), options);
  }

  /**
   * Check your schedule clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Check%20your%20schedule%20clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. account_id)
   * @param options Amplitude event options.
   */
  checkYourScheduleClicked(
    properties: CheckYourScheduleClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CheckYourScheduleClicked(properties), options);
  }

  /**
   * Clicked ANT banner
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Clicked%20ANT%20banner)
   *
   * The seller clicked on the ANT-sell banner.
   *
   * @param properties The event's properties (e.g. url)
   * @param options Amplitude event options.
   */
  clickedAntBanner(
    properties?: ClickedAntBannerProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickedAntBanner(properties), options);
  }

  /**
   * Clicked button to pay seller
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Clicked%20button%20to%20pay%20seller)
   *
   * This event tracks when a user clicks on the button to initiate a payment to a seller at the end of the iwocaPay drawdown.
   *
   * @param options Amplitude event options.
   */
  clickedButtonToPaySeller(
    options?: EventOptions,
  ) {
    return this.track(new ClickedButtonToPaySeller(), options);
  }

  /**
   * Clicked x-sell banner
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Clicked%20x-sell%20banner)
   *
   * The seller clicked on the x-sell banner.
   *
   * @param properties The event's properties (e.g. url)
   * @param options Amplitude event options.
   */
  clickedXSellBanner(
    properties?: ClickedXSellBannerProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickedXSellBanner(properties), options);
  }

  /**
   * Company accounts upload clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Company%20accounts%20upload%20clicked)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param options Amplitude event options.
   */
  companyAccountsUploadClicked(
    options?: EventOptions,
  ) {
    return this.track(new CompanyAccountsUploadClicked(), options);
  }

  /**
   * Company accounts uploaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Company%20accounts%20uploaded)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param options Amplitude event options.
   */
  companyAccountsUploaded(
    options?: EventOptions,
  ) {
    return this.track(new CompanyAccountsUploaded(), options);
  }

  /**
   * Company name search secondary selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Company%20name%20search%20secondary%20selected)
   *
   * This event tracks when a user selects the option to return to the auto company search while searching for a company name during the sign-up process
   *
   * @param options Amplitude event options.
   */
  companyNameSearchSecondarySelected(
    options?: EventOptions,
  ) {
    return this.track(new CompanyNameSearchSecondarySelected(), options);
  }

  /**
   * Company name searched
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Company%20name%20searched)
   *
   * This event tracks when a user the auto search to search for a specific company name during the sign-up process
   *
   * @param options Amplitude event options.
   */
  companyNameSearched(
    options?: EventOptions,
  ) {
    return this.track(new CompanyNameSearched(), options);
  }

  /**
   * Company type selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Company%20type%20selected)
   *
   * This event tracks when a user selects their company type during the sign-up process
   *
   * @param properties The event's properties (e.g. company_type)
   * @param options Amplitude event options.
   */
  companyTypeSelected(
    properties: CompanyTypeSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CompanyTypeSelected(properties), options);
  }

  /**
   * Complete payment clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Complete%20payment%20clicked)
   *
   * Event Description: This event is triggered when a user clicks on the "Complete Payment" button which takes the buyer to the iwocaPay drawdown screens.
   *
   * @param options Amplitude event options.
   */
  completePaymentClicked(
    options?: EventOptions,
  ) {
    return this.track(new CompletePaymentClicked(), options);
  }

  /**
   * Copy required documents clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Copy%20required%20documents%20clicked)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  copyRequiredDocumentsClicked(
    properties?: CopyRequiredDocumentsClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CopyRequiredDocumentsClicked(properties), options);
  }

  /**
   * Dashboard viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Dashboard%20viewed)
   *
   * Owner: Connor Meredith
   *
   * @param properties The event's properties (e.g. account_id)
   * @param options Amplitude event options.
   */
  dashboardViewed(
    properties: DashboardViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DashboardViewed(properties), options);
  }

  /**
   * Decision modal viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Decision%20modal%20viewed)
   *
   * The buyer has completed the signup and seen the decision modal.
   *
   * @param properties The event's properties (e.g. decision_modal_state)
   * @param options Amplitude event options.
   */
  decisionModalViewed(
    properties: DecisionModalViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DecisionModalViewed(properties), options);
  }

  /**
   * Directors profile submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Directors%20profile%20submitted)
   *
   * Submitted directors profile as part of the iwocaPay seller account activation.
   *
   * @param options Amplitude event options.
   */
  directorsProfileSubmitted(
    options?: EventOptions,
  ) {
    return this.track(new DirectorsProfileSubmitted(), options);
  }

  /**
   * Displayed ANT banner
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Displayed%20ANT%20banner)
   *
   * The ANT banner was presented to a seller
   *
   * @param properties The event's properties (e.g. url)
   * @param options Amplitude event options.
   */
  displayedAntBanner(
    properties?: DisplayedAntBannerProperties,
    options?: EventOptions,
  ) {
    return this.track(new DisplayedAntBanner(properties), options);
  }

  /**
   * Displayed x-sell banner
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Displayed%20x-sell%20banner)
   *
   * The x-sell banner was presented to a seller
   *
   * @param properties The event's properties (e.g. url)
   * @param options Amplitude event options.
   */
  displayedXSellBanner(
    properties?: DisplayedXSellBannerProperties,
    options?: EventOptions,
  ) {
    return this.track(new DisplayedXSellBanner(properties), options);
  }

  /**
   * Doc upload banner - link clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Doc%20upload%20banner%20-%20link%20clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  docUploadBannerLinkClicked(
    options?: EventOptions,
  ) {
    return this.track(new DocUploadBannerLinkClicked(), options);
  }

  /**
   * Drawdown - complete application step viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Drawdown%20-%20complete%20application%20step%20viewed)
   *
   * Owner: Connor Meredith
   *
   * @param properties The event's properties (e.g. amount)
   * @param options Amplitude event options.
   */
  drawdownCompleteApplicationStepViewed(
    properties: DrawdownCompleteApplicationStepViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DrawdownCompleteApplicationStepViewed(properties), options);
  }

  /**
   * Drawdown - completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Drawdown%20-%20completed)
   *
   * Customer has successfully drawn down.
   *
   * Owner: Connor Meredith
   *
   * @param properties The event's properties (e.g. amount)
   * @param options Amplitude event options.
   */
  drawdownCompleted(
    properties: DrawdownCompletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DrawdownCompleted(properties), options);
  }

  /**
   * Drawdown - confirm clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Drawdown%20-%20confirm%20clicked)
   *
   * Customer has submitted the request to draw down.
   *
   * Owner: Connor Meredith
   *
   * @param properties The event's properties (e.g. amount)
   * @param options Amplitude event options.
   */
  drawdownConfirmClicked(
    properties: DrawdownConfirmClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DrawdownConfirmClicked(properties), options);
  }

  /**
   * Drawdown - confirm step viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Drawdown%20-%20confirm%20step%20viewed)
   *
   * Customer views the confirm step of the drawdown.
   *
   * Owner: Connor Meredith
   *
   * @param properties The event's properties (e.g. amount)
   * @param options Amplitude event options.
   */
  drawdownConfirmStepViewed(
    properties: DrawdownConfirmStepViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DrawdownConfirmStepViewed(properties), options);
  }

  /**
   * Drawdown - MSH form opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Drawdown%20-%20MSH%20form%20opened)
   *
   * Customer clicked on the add person button to open the add person form
   *
   * Owner: Will F
   *
   * @param options Amplitude event options.
   */
  drawdownMshFormOpened(
    options?: EventOptions,
  ) {
    return this.track(new DrawdownMshFormOpened(), options);
  }

  /**
   * Drawdown - MSH modal opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Drawdown%20-%20MSH%20modal%20opened)
   *
   * Customers in the add_msh_drawdown_modal split test opened the modal to resolve the MSH funding requirement
   *
   * Owner: Will F
   *
   * @param options Amplitude event options.
   */
  drawdownMshModalOpened(
    options?: EventOptions,
  ) {
    return this.track(new DrawdownMshModalOpened(), options);
  }

  /**
   * Drawdown - MSH person added
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Drawdown%20-%20MSH%20person%20added)
   *
   * Customer saved their form entry in the add person form and the perosn was successfully saved to customer_state
   *
   * Owner: Will F
   *
   * @param options Amplitude event options.
   */
  drawdownMshPersonAdded(
    options?: EventOptions,
  ) {
    return this.track(new DrawdownMshPersonAdded(), options);
  }

  /**
   * Drawdown - sign documents step viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Drawdown%20-%20sign%20documents%20step%20viewed)
   *
   * Customer views the sign documents step of the drawdown.
   *
   * Owner: Connor Meredith
   *
   * @param properties The event's properties (e.g. amount)
   * @param options Amplitude event options.
   */
  drawdownSignDocumentsStepViewed(
    properties: DrawdownSignDocumentsStepViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DrawdownSignDocumentsStepViewed(properties), options);
  }

  /**
   * Drawdown - started
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Drawdown%20-%20started)
   *
   * Customer starts the drawdown journey.
   *
   * Owner: Connor Meredith
   *
   * @param properties The event's properties (e.g. amount)
   * @param options Amplitude event options.
   */
  drawdownStarted(
    properties: DrawdownStartedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DrawdownStarted(properties), options);
  }

  /**
   * Early Repayment Calculator Link clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Early%20Repayment%20Calculator%20Link%20clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. formal_offer_id)
   * @param options Amplitude event options.
   */
  earlyRepaymentCalculatorLinkClicked(
    properties: EarlyRepaymentCalculatorLinkClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EarlyRepaymentCalculatorLinkClicked(properties), options);
  }

  /**
   * Early Repayment Calculator Used
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Early%20Repayment%20Calculator%20Used)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. early_repayment_date)
   * @param options Amplitude event options.
   */
  earlyRepaymentCalculatorUsed(
    properties: EarlyRepaymentCalculatorUsedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EarlyRepaymentCalculatorUsed(properties), options);
  }

  /**
   * edit amount opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/edit%20amount%20opened)
   *
   * Owner: r.maimon@iwoca.co.uk
   *
   * @param properties The event's properties (e.g. amount)
   * @param options Amplitude event options.
   */
  editAmountOpened(
    properties: EditAmountOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EditAmountOpened(properties), options);
  }

  /**
   * Email required documents clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Email%20required%20documents%20clicked)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  emailRequiredDocumentsClicked(
    properties?: EmailRequiredDocumentsClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EmailRequiredDocumentsClicked(properties), options);
  }

  /**
   * Exit security checks early
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Exit%20security%20checks%20early)
   *
   * This event tracks when a user exits the security checks early during the spending limit process
   *
   * @param options Amplitude event options.
   */
  exitSecurityChecksEarly(
    options?: EventOptions,
  ) {
    return this.track(new ExitSecurityChecksEarly(), options);
  }

  /**
   * External link clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/External%20link%20clicked)
   *
   * Owner: Emma Haines
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  externalLinkClicked(
    properties: ExternalLinkClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ExternalLinkClicked(properties), options);
  }

  /**
   * FCA regulated clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/FCA%20regulated%20clicked)
   *
   * Owner: Jack Saunders
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  fcaRegulatedClicked(
    properties?: FcaRegulatedClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FcaRegulatedClicked(properties), options);
  }

  /**
   * Finished seller signup
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Finished%20seller%20signup)
   *
   * Finished iwocaPay seller account activation.
   *
   * @param options Amplitude event options.
   */
  finishedSellerSignup(
    options?: EventOptions,
  ) {
    return this.track(new FinishedSellerSignup(), options);
  }

  /**
   * Form field completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Form%20field%20completed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. form_field)
   * @param options Amplitude event options.
   */
  formFieldCompleted(
    properties: FormFieldCompletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FormFieldCompleted(properties), options);
  }

  /**
   * Form field started
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Form%20field%20started)
   *
   * This event tracks when a user begins filling out a form field
   *
   * @param properties The event's properties (e.g. form_field)
   * @param options Amplitude event options.
   */
  formFieldStarted(
    properties: FormFieldStartedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FormFieldStarted(properties), options);
  }

  /**
   * Formal offer selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Formal%20offer%20selected)
   *
   * This event tracks when a formal offer has been selected by a user on muli-offer views.
   *
   * @param properties The event's properties (e.g. formal_offer_id)
   * @param options Amplitude event options.
   */
  formalOfferSelected(
    properties: FormalOfferSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FormalOfferSelected(properties), options);
  }

  /**
   * Formalised auto offer greater than the requested amount
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Formalised%20auto%20offer%20greater%20than%20the%20requested%20amount)
   *
   * The frontend formalises some auto offers if the auto offer amount is greater than the requested amount, and the auto product key is not the suggested product. 
   *
   * See coda for detailed info  
   *  https://coda.io/d/New-Applications-Team_dTHYDMUkpe0/Auto-formalisation-of-Auto-offers-in-the-manual-segment_suFdR?utm_source=slack#\_luY_C
   *
   * @param properties The event's properties (e.g. formalised_product_keys)
   * @param options Amplitude event options.
   */
  formalisedAutoOfferGreaterThanTheRequestedAmount(
    properties: FormalisedAutoOfferGreaterThanTheRequestedAmountProperties,
    options?: EventOptions,
  ) {
    return this.track(new FormalisedAutoOfferGreaterThanTheRequestedAmount(properties), options);
  }

  /**
   * Help method selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Help%20method%20selected)
   *
   * Owner: r.maimon@iwoca.co.uk
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  helpMethodSelected(
    properties?: HelpMethodSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new HelpMethodSelected(properties), options);
  }

  /**
   * Help opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Help%20opened)
   *
   * Owner: r.maimon@iwoca.co.uk
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  helpOpened(
    properties: HelpOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new HelpOpened(properties), options);
  }

  /**
   * Homescreen banner - closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Homescreen%20banner%20-%20closed)
   *
   * This event tracks when a user closes the homescreen banner
   *
   * @param options Amplitude event options.
   */
  homescreenBannerClosed(
    options?: EventOptions,
  ) {
    return this.track(new HomescreenBannerClosed(), options);
  }

  /**
   * Homescreen banner - link clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Homescreen%20banner%20-%20link%20clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. Link type)
   * @param options Amplitude event options.
   */
  homescreenBannerLinkClicked(
    properties: HomescreenBannerLinkClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new HomescreenBannerLinkClicked(properties), options);
  }

  /**
   * Indicative Offers viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Indicative%20Offers%20viewed)
   *
   * Owner: Emma Haines
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  indicativeOffersViewed(
    properties: IndicativeOffersViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new IndicativeOffersViewed(properties), options);
  }

  /**
   * Instant decision CTA clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Instant%20decision%20CTA%20clicked)
   *
   * Owner: Emma Haines
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  instantDecisionCtaClicked(
    properties?: InstantDecisionCtaClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InstantDecisionCtaClicked(properties), options);
  }

  /**
   * Internal link clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Internal%20link%20clicked)
   *
   * Owner: Emma Haines
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  internalLinkClicked(
    properties: InternalLinkClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InternalLinkClicked(properties), options);
  }

  /**
   * Lending decision errored
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Lending%20decision%20errored)
   *
   * Owner: Emma Haines
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  lendingDecisionErrored(
    properties?: LendingDecisionErroredProperties,
    options?: EventOptions,
  ) {
    return this.track(new LendingDecisionErrored(properties), options);
  }

  /**
   * Linked repayment card
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Linked%20repayment%20card)
   *
   * Tracks when a repayment card is linked to an iwocaPay account
   *
   * @param options Amplitude event options.
   */
  linkedRepaymentCard(
    options?: EventOptions,
  ) {
    return this.track(new LinkedRepaymentCard(), options);
  }

  /**
   * Login link requested
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Login%20link%20requested)
   *
   * A login link was requested by a user on an iwocaPay landing page.
   *
   * @param options Amplitude event options.
   */
  loginLinkRequested(
    options?: EventOptions,
  ) {
    return this.track(new LoginLinkRequested(), options);
  }

  /**
   * Logout clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Logout%20clicked)
   *
   * Owner: r.maimon@iwoca.co.uk
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  logoutClicked(
    properties?: LogoutClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new LogoutClicked(properties), options);
  }

  /**
   * Management accounts upload clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Management%20accounts%20upload%20clicked)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param options Amplitude event options.
   */
  managementAccountsUploadClicked(
    options?: EventOptions,
  ) {
    return this.track(new ManagementAccountsUploadClicked(), options);
  }

  /**
   * Management accounts uploaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Management%20accounts%20uploaded)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param options Amplitude event options.
   */
  managementAccountsUploaded(
    options?: EventOptions,
  ) {
    return this.track(new ManagementAccountsUploaded(), options);
  }

  /**
   * Manual company name completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Manual%20company%20name%20completed)
   *
   * This event tracks when a user manually enters their company name during the sign-up process
   *
   * @param options Amplitude event options.
   */
  manualCompanyNameCompleted(
    options?: EventOptions,
  ) {
    return this.track(new ManualCompanyNameCompleted(), options);
  }

  /**
   * Manual company name selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Manual%20company%20name%20selected)
   *
   * This event tracks when a user manually selects the button to enter the company name manually in a sign up process
   *
   * @param properties The event's properties (e.g. location_clicked_from)
   * @param options Amplitude event options.
   */
  manualCompanyNameSelected(
    properties: ManualCompanyNameSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ManualCompanyNameSelected(properties), options);
  }

  /**
   * Mobile loan summary openend
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Mobile%20loan%20summary%20openend)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  mobileLoanSummaryOpenend(
    options?: EventOptions,
  ) {
    return this.track(new MobileLoanSummaryOpenend(), options);
  }

  /**
   * My offers visited
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/My%20offers%20visited)
   *
   * Owner: Ariel Wolffe-Shah
   *
   * @param properties The event's properties (e.g. application_status)
   * @param options Amplitude event options.
   */
  myOffersVisited(
    properties?: MyOffersVisitedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MyOffersVisited(properties), options);
  }

  /**
   * New doc uploads - clicked edit amount
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20clicked%20edit%20amount)
   *
   * This event tracks when a user clicks on the "edit amount" button in the new doc uploads page
   *
   * @param options Amplitude event options.
   */
  newDocUploadsClickedEditAmount(
    options?: EventOptions,
  ) {
    return this.track(new NewDocUploadsClickedEditAmount(), options);
  }

  /**
   * New doc uploads - clicked link bank account section
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20clicked%20link%20bank%20account%20section)
   *
   * This event tracks when a user clicks on the link bank account radio button
   *
   * @param options Amplitude event options.
   */
  newDocUploadsClickedLinkBankAccountSection(
    options?: EventOptions,
  ) {
    return this.track(new NewDocUploadsClickedLinkBankAccountSection(), options);
  }

  /**
   * New doc uploads - clicked manual bank statement section
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20clicked%20manual%20bank%20statement%20section)
   *
   * This event tracks when a user clicks on the manual bank statement radio button
   *
   * @param options Amplitude event options.
   */
  newDocUploadsClickedManualBankStatementSection(
    options?: EventOptions,
  ) {
    return this.track(new NewDocUploadsClickedManualBankStatementSection(), options);
  }

  /**
   * New doc uploads - clicked submit application
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20clicked%20submit%20application)
   *
   * This event tracks when a user clicks the "submit application" button
   *
   * @param options Amplitude event options.
   */
  newDocUploadsClickedSubmitApplication(
    options?: EventOptions,
  ) {
    return this.track(new NewDocUploadsClickedSubmitApplication(), options);
  }

  /**
   * New doc uploads - document upload failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20document%20upload%20failed)
   *
   * This event tracks when a doc upload attempt failed
   *
   * @param properties The event's properties (e.g. Document name)
   * @param options Amplitude event options.
   */
  newDocUploadsDocumentUploadFailed(
    properties: NewDocUploadsDocumentUploadFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new NewDocUploadsDocumentUploadFailed(properties), options);
  }

  /**
   * New doc uploads - page viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20page%20viewed)
   *
   * This event tracks when a user viewsnew doc uploads page
   *
   * @param options Amplitude event options.
   */
  newDocUploadsPageViewed(
    options?: EventOptions,
  ) {
    return this.track(new NewDocUploadsPageViewed(), options);
  }

  /**
   * New doc uploads - requirements outstanding
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20requirements%20outstanding)
   *
   * This event tracks when an app is submitted but there are still outstanding requirements
   *
   * @param options Amplitude event options.
   */
  newDocUploadsRequirementsOutstanding(
    options?: EventOptions,
  ) {
    return this.track(new NewDocUploadsRequirementsOutstanding(), options);
  }

  /**
   * New doc uploads - resolved all requirements
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20resolved%20all%20requirements)
   *
   * This event tracks when a user submits their app and has successfully resolved all the requirements
   *
   * @param options Amplitude event options.
   */
  newDocUploadsResolvedAllRequirements(
    options?: EventOptions,
  ) {
    return this.track(new NewDocUploadsResolvedAllRequirements(), options);
  }

  /**
   * New doc uploads - successfully linked bank account via truelayer
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20successfully%20linked%20bank%20account%20via%20truelayer)
   *
   * This event tracks when a user successfully links their bank account via Truelayer
   *
   * @param options Amplitude event options.
   */
  newDocUploadsSuccessfullyLinkedBankAccountViaTruelayer(
    options?: EventOptions,
  ) {
    return this.track(new NewDocUploadsSuccessfullyLinkedBankAccountViaTruelayer(), options);
  }

  /**
   * New doc uploads - successfully uploaded document
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20successfully%20uploaded%20document)
   *
   * Tracks successful upload of new document
   *
   * @param properties The event's properties (e.g. Document name)
   * @param options Amplitude event options.
   */
  newDocUploadsSuccessfullyUploadedDocument(
    properties: NewDocUploadsSuccessfullyUploadedDocumentProperties,
    options?: EventOptions,
  ) {
    return this.track(new NewDocUploadsSuccessfullyUploadedDocument(properties), options);
  }

  /**
   * New loan - application step submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20loan%20-%20application%20step%20submitted)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  newLoanApplicationStepSubmitted(
    options?: EventOptions,
  ) {
    return this.track(new NewLoanApplicationStepSubmitted(), options);
  }

  /**
   * New loan - application step viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20loan%20-%20application%20step%20viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  newLoanApplicationStepViewed(
    options?: EventOptions,
  ) {
    return this.track(new NewLoanApplicationStepViewed(), options);
  }

  /**
   * New loan - documents step submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20loan%20-%20documents%20step%20submitted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  newLoanDocumentsStepSubmitted(
    properties?: NewLoanDocumentsStepSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new NewLoanDocumentsStepSubmitted(properties), options);
  }

  /**
   * New loan - documents step viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20loan%20-%20documents%20step%20viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  newLoanDocumentsStepViewed(
    properties: NewLoanDocumentsStepViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new NewLoanDocumentsStepViewed(properties), options);
  }

  /**
   * New loan - request completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20loan%20-%20request%20completed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  newLoanRequestCompleted(
    properties?: NewLoanRequestCompletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new NewLoanRequestCompleted(properties), options);
  }

  /**
   * New loan - request started
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20loan%20-%20request%20started)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. account_id)
   * @param options Amplitude event options.
   */
  newLoanRequestStarted(
    properties: NewLoanRequestStartedProperties,
    options?: EventOptions,
  ) {
    return this.track(new NewLoanRequestStarted(properties), options);
  }

  /**
   * Offer selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Offer%20selected)
   *
   * Owner: Emma Haines
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  offerSelected(
    properties: OfferSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new OfferSelected(properties), options);
  }

  /**
   * Offers page viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Offers%20page%20viewed)
   *
   * A buyer was presented with multiple offers within the buyer signup.
   *
   * @param properties The event's properties (e.g. offer_ids)
   * @param options Amplitude event options.
   */
  offersPageViewed(
    properties: OffersPageViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new OffersPageViewed(properties), options);
  }

  /**
   * Open banking connect started
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Open%20banking%20connect%20started)
   *
   * Owner: r.maimon@iwoca.co.uk
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  openBankingConnectStarted(
    properties?: OpenBankingConnectStartedProperties,
    options?: EventOptions,
  ) {
    return this.track(new OpenBankingConnectStarted(properties), options);
  }

  /**
   * Open banking finished
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Open%20banking%20finished)
   *
   * Owner: r.maimon@iwoca.co.uk
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  openBankingFinished(
    properties?: OpenBankingFinishedProperties,
    options?: EventOptions,
  ) {
    return this.track(new OpenBankingFinished(properties), options);
  }

  /**
   * Open banking linked successfully
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Open%20banking%20linked%20successfully)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param options Amplitude event options.
   */
  openBankingLinkedSuccessfully(
    options?: EventOptions,
  ) {
    return this.track(new OpenBankingLinkedSuccessfully(), options);
  }

  /**
   * Open banking linking cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Open%20banking%20linking%20cancelled)
   *
   * Owner: Jack Saunders
   *
   * @param options Amplitude event options.
   */
  openBankingLinkingCancelled(
    options?: EventOptions,
  ) {
    return this.track(new OpenBankingLinkingCancelled(), options);
  }

  /**
   * Open banking linking failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Open%20banking%20linking%20failed)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param options Amplitude event options.
   */
  openBankingLinkingFailed(
    options?: EventOptions,
  ) {
    return this.track(new OpenBankingLinkingFailed(), options);
  }

  /**
   * Open banking modal closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Open%20banking%20modal%20closed)
   *
   * Owner: r.maimon@iwoca.co.uk
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  openBankingModalClosed(
    properties?: OpenBankingModalClosedProperties,
    options?: EventOptions,
  ) {
    return this.track(new OpenBankingModalClosed(properties), options);
  }

  /**
   * Open banking modal opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Open%20banking%20modal%20opened)
   *
   * Event for when the truelayer implementation had a mopdal that opened before you clicked through to their website, no longer in use on signup.
   *
   * Owner: r.maimon@iwoca.co.uk
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  openBankingModalOpened(
    properties?: OpenBankingModalOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new OpenBankingModalOpened(properties), options);
  }

  /**
   * Pay link copied
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Pay%20link%20copied)
   *
   * A pay link url was copied.
   *
   * @param properties The event's properties (e.g. url)
   * @param options Amplitude event options.
   */
  payLinkCopied(
    properties?: PayLinkCopiedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PayLinkCopied(properties), options);
  }

  /**
   * Pay link landing page viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Pay%20link%20landing%20page%20viewed)
   *
   * A user viewed the landing page for a pay link.
   *
   * @param properties The event's properties (e.g. pay_link_id)
   * @param options Amplitude event options.
   */
  payLinkLandingPageViewed(
    properties: PayLinkLandingPageViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PayLinkLandingPageViewed(properties), options);
  }

  /**
   * Payment option selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Payment%20option%20selected)
   *
   * A buyer selected a payment option on a pay link landing page.
   *
   * @param properties The event's properties (e.g. pay_link_type)
   * @param options Amplitude event options.
   */
  paymentOptionSelected(
    properties: PaymentOptionSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PaymentOptionSelected(properties), options);
  }

  /**
   * Payment option submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Payment%20option%20submitted)
   *
   * A buyer submitted their selection of a payment option on a pay link landing page.
   *
   * @param properties The event's properties (e.g. pay_link_type)
   * @param options Amplitude event options.
   */
  paymentOptionSubmitted(
    properties: PaymentOptionSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PaymentOptionSubmitted(properties), options);
  }

  /**
   * Personal details submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Personal%20details%20submitted)
   *
   * Owner: Jack Saunders
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  personalDetailsSubmitted(
    properties: PersonalDetailsSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PersonalDetailsSubmitted(properties), options);
  }

  /**
   * Phone number clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Phone%20number%20clicked)
   *
   * This event tracks when a user clicks on a phone number
   *
   * @param properties The event's properties (e.g. location_clicked_from)
   * @param options Amplitude event options.
   */
  phoneNumberClicked(
    properties: PhoneNumberClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PhoneNumberClicked(properties), options);
  }

  /**
   * Product offers load time
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Product%20offers%20load%20time)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. duration)
   * @param options Amplitude event options.
   */
  productOffersLoadTime(
    properties: ProductOffersLoadTimeProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProductOffersLoadTime(properties), options);
  }

  /**
   * Profile opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Profile%20opened)
   *
   * Owner: r.maimon@iwoca.co.uk
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  profileOpened(
    properties?: ProfileOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProfileOpened(properties), options);
  }

  /**
   * Progress bar clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Progress%20bar%20clicked)
   *
   * Owner: Emma Haines
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  progressBarClicked(
    properties?: ProgressBarClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProgressBarClicked(properties), options);
  }

  /**
   * Refresh spending limit button clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Refresh%20spending%20limit%20button%20clicked)
   *
   * Triggered when the "Refresh spending limit" button is clicked by an iwocapay buyer
   *
   * @param options Amplitude event options.
   */
  refreshSpendingLimitButtonClicked(
    options?: EventOptions,
  ) {
    return this.track(new RefreshSpendingLimitButtonClicked(), options);
  }

  /**
   * repayment card linked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/repayment%20card%20linked)
   *
   * Buyer linked repayment card in the iwocapay drawdown
   *
   * @param options Amplitude event options.
   */
  repaymentCardLinked(
    options?: EventOptions,
  ) {
    return this.track(new RepaymentCardLinked(), options);
  }

  /**
   * Repayment schedule viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Repayment%20schedule%20viewed)
   *
   * Owner: Emma Haines
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  repaymentScheduleViewed(
    properties?: RepaymentScheduleViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RepaymentScheduleViewed(properties), options);
  }

  /**
   * Request more funds clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Request%20more%20funds%20clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. account_id)
   * @param options Amplitude event options.
   */
  requestMoreFundsClicked(
    properties: RequestMoreFundsClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RequestMoreFundsClicked(properties), options);
  }

  /**
   * Requested amount changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Requested%20amount%20changed)
   *
   * Owner: r.maimon@iwoca.co.uk
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  requestedAmountChanged(
    properties?: RequestedAmountChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RequestedAmountChanged(properties), options);
  }

  /**
   * Save application clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Save%20application%20clicked)
   *
   * Owner: r.maimon@iwoca.co.uk
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  saveApplicationClicked(
    properties?: SaveApplicationClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SaveApplicationClicked(properties), options);
  }

  /**
   * Selected checkout option
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Selected%20checkout%20option)
   *
   * This event tracks when a user selects a checkout option during the iwocaPay buyer journey
   *
   * @param properties The event's properties (e.g. pay_link_id)
   * @param options Amplitude event options.
   */
  selectedCheckoutOption(
    properties: SelectedCheckoutOptionProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectedCheckoutOption(properties), options);
  }

  /**
   * Selected offer
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Selected%20offer)
   *
   * A buyer selected one out of multiple offers presented during the signup journey.
   *
   * @param properties The event's properties (e.g. offer_id)
   * @param options Amplitude event options.
   */
  selectedOffer(
    properties: SelectedOfferProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectedOffer(properties), options);
  }

  /**
   * Seller documents uploaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Seller%20documents%20uploaded)
   *
   * Uploaded seller documents as part of the iwocaPay seller account activation.
   *
   * @param options Amplitude event options.
   */
  sellerDocumentsUploaded(
    options?: EventOptions,
  ) {
    return this.track(new SellerDocumentsUploaded(), options);
  }

  /**
   * Seller email added
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Seller%20email%20added)
   *
   * Seller added an email to their account as part of the iwocaPay seller account activation.
   *
   * @param options Amplitude event options.
   */
  sellerEmailAdded(
    options?: EventOptions,
  ) {
    return this.track(new SellerEmailAdded(), options);
  }

  /**
   * Share required documents closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Share%20required%20documents%20closed)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  shareRequiredDocumentsClosed(
    properties?: ShareRequiredDocumentsClosedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ShareRequiredDocumentsClosed(properties), options);
  }

  /**
   * Share required documents opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Share%20required%20documents%20opened)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  shareRequiredDocumentsOpened(
    properties?: ShareRequiredDocumentsOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ShareRequiredDocumentsOpened(properties), options);
  }

  /**
   * Signup completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Signup%20completed)
   *
   * Owner: r.maimon@iwoca.co.uk
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  signupCompleted(
    properties?: SignupCompletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SignupCompleted(properties), options);
  }

  /**
   * Skipped to standard decision
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Skipped%20to%20standard%20decision)
   *
   * This event tracks when a user skips to the standard decision step on the optional bank statements version of the trading history page.
   *
   * @param options Amplitude event options.
   */
  skippedToStandardDecision(
    options?: EventOptions,
  ) {
    return this.track(new SkippedToStandardDecision(), options);
  }

  /**
   * Spending limit viewed other terms
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Spending%20limit%20viewed%20other%20terms)
   *
   * This event tracks when a user views other terms while viewing their spending limit
   *
   * @param options Amplitude event options.
   */
  spendingLimitViewedOtherTerms(
    options?: EventOptions,
  ) {
    return this.track(new SpendingLimitViewedOtherTerms(), options);
  }

  /**
   * Spill banner - closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Spill%20banner%20-%20closed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  spillBannerClosed(
    options?: EventOptions,
  ) {
    return this.track(new SpillBannerClosed(), options);
  }

  /**
   * Spill banner - link clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Spill%20banner%20-%20link%20clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  spillBannerLinkClicked(
    options?: EventOptions,
  ) {
    return this.track(new SpillBannerLinkClicked(), options);
  }

  /**
   * Started security checks early
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Started%20security%20checks%20early)
   *
   * User initiates the security checks ahead of time for spending limit in iwocaPay
   *
   * @param options Amplitude event options.
   */
  startedSecurityChecksEarly(
    options?: EventOptions,
  ) {
    return this.track(new StartedSecurityChecksEarly(), options);
  }

  /**
   * Step loaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Step%20loaded)
   *
   * Owner: Emma Haines
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  stepLoaded(
    properties?: StepLoadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new StepLoaded(properties), options);
  }

  /**
   * Submitted x-sell application
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Submitted%20x-sell%20application)
   *
   * A x-sell application was submitted by the seller after being presented with the x-sell banner.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  submittedXSellApplication(
    properties?: SubmittedXSellApplicationProperties,
    options?: EventOptions,
  ) {
    return this.track(new SubmittedXSellApplication(properties), options);
  }

  /**
   * Switched to core business dashboard
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Switched%20to%20core%20business%20dashboard)
   *
   * User clicked a button on the iwocaPay dashboard to switch to the pandora dashboard.
   *
   * @param properties The event's properties (e.g. url)
   * @param options Amplitude event options.
   */
  switchedToCoreBusinessDashboard(
    properties?: SwitchedToCoreBusinessDashboardProperties,
    options?: EventOptions,
  ) {
    return this.track(new SwitchedToCoreBusinessDashboard(properties), options);
  }

  /**
   * Switched to iwocaPay dashboard
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Switched%20to%20iwocaPay%20dashboard)
   *
   * User clicked a button on the pandora dashboard to switch to the iwocaPay dashboard.
   *
   * @param properties The event's properties (e.g. url)
   * @param options Amplitude event options.
   */
  switchedToIwocaPayDashboard(
    properties?: SwitchedToIwocaPayDashboardProperties,
    options?: EventOptions,
  ) {
    return this.track(new SwitchedToIwocaPayDashboard(properties), options);
  }

  /**
   * Topup - Inline form application step submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20-%20Inline%20form%20application%20step%20submitted)
   *
   * Owner: Connor Meredith
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  topupInlineFormApplicationStepSubmitted(
    properties?: TopupInlineFormApplicationStepSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TopupInlineFormApplicationStepSubmitted(properties), options);
  }

  /**
   * Topup - Inline form application step viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20-%20Inline%20form%20application%20step%20viewed)
   *
   * Owner: Connor Meredith
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  topupInlineFormApplicationStepViewed(
    properties?: TopupInlineFormApplicationStepViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TopupInlineFormApplicationStepViewed(properties), options);
  }

  /**
   * Topup - Inline form documents step submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20-%20Inline%20form%20documents%20step%20submitted)
   *
   * Owner: Connor Meredith
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  topupInlineFormDocumentsStepSubmitted(
    properties?: TopupInlineFormDocumentsStepSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TopupInlineFormDocumentsStepSubmitted(properties), options);
  }

  /**
   * Topup - Inline form documents step viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20-%20Inline%20form%20documents%20step%20viewed)
   *
   * Owner: Connor Meredith
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  topupInlineFormDocumentsStepViewed(
    properties?: TopupInlineFormDocumentsStepViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TopupInlineFormDocumentsStepViewed(properties), options);
  }

  /**
   * Topup - Reapply form application step submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20-%20Reapply%20form%20application%20step%20submitted)
   *
   * Owner: Freddie Wellfair
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  topupReapplyFormApplicationStepSubmitted(
    properties?: TopupReapplyFormApplicationStepSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TopupReapplyFormApplicationStepSubmitted(properties), options);
  }

  /**
   * Topup - Reapply form application step viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20-%20Reapply%20form%20application%20step%20viewed)
   *
   * Owner: Freddie Wellfair
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  topupReapplyFormApplicationStepViewed(
    properties?: TopupReapplyFormApplicationStepViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TopupReapplyFormApplicationStepViewed(properties), options);
  }

  /**
   * Topup - Reapply form documents step submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20-%20Reapply%20form%20documents%20step%20submitted)
   *
   * Owner: Freddie Wellfair
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  topupReapplyFormDocumentsStepSubmitted(
    properties?: TopupReapplyFormDocumentsStepSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TopupReapplyFormDocumentsStepSubmitted(properties), options);
  }

  /**
   * Topup - Reapply form documents step viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20-%20Reapply%20form%20documents%20step%20viewed)
   *
   * Owner: Freddie Wellfair
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  topupReapplyFormDocumentsStepViewed(
    properties?: TopupReapplyFormDocumentsStepViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TopupReapplyFormDocumentsStepViewed(properties), options);
  }

  /**
   * Topup - Request completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20-%20Request%20completed)
   *
   * Owner: Connor Meredith
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  topupRequestCompleted(
    properties?: TopupRequestCompletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TopupRequestCompleted(properties), options);
  }

  /**
   * Topup request started
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20request%20started)
   *
   * Owner: Connor Meredith
   *
   * @param properties The event's properties (e.g. account_id)
   * @param options Amplitude event options.
   */
  topupRequestStarted(
    properties: TopupRequestStartedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TopupRequestStarted(properties), options);
  }

  /**
   * Trading history submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Trading%20history%20submitted)
   *
   * Owner: Jack Saunders
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  tradingHistorySubmitted(
    properties: TradingHistorySubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TradingHistorySubmitted(properties), options);
  }

  /**
   * Trading history viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Trading%20history%20viewed)
   *
   * The trading history page is opened and all the requirements have loaded
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param properties The event's properties (e.g. Aged debtor report required)
   * @param options Amplitude event options.
   */
  tradingHistoryViewed(
    properties: TradingHistoryViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TradingHistoryViewed(properties), options);
  }

  /**
   * TrueLayer bank connect started
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/TrueLayer%20bank%20connect%20started)
   *
   * This event tracks when a user starts the process of connecting their bank account with TrueLayer during the sign-up process
   *
   * @param properties The event's properties (e.g. bankId)
   * @param options Amplitude event options.
   */
  trueLayerBankConnectStarted(
    properties?: TrueLayerBankConnectStartedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TrueLayerBankConnectStarted(properties), options);
  }

  /**
   * TrueLayer bank selection
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/TrueLayer%20bank%20selection)
   *
   * This event tracks when a user selects a bank during the sign-up process on TrueLayer
   *
   * @param properties The event's properties (e.g. bankId)
   * @param options Amplitude event options.
   */
  trueLayerBankSelection(
    properties: TrueLayerBankSelectionProperties,
    options?: EventOptions,
  ) {
    return this.track(new TrueLayerBankSelection(properties), options);
  }

  /**
   * TrueLayer modal closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/TrueLayer%20modal%20closed)
   *
   * This event tracks when a user closes the TrueLayer consent flow modal during the sign-up Trading History process
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  trueLayerModalClosed(
    properties?: TrueLayerModalClosedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TrueLayerModalClosed(properties), options);
  }

  /**
   * Upload bank statements clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Upload%20bank%20statements%20clicked)
   *
   * Owner: r.maimon@iwoca.co.uk
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  uploadBankStatementsClicked(
    properties?: UploadBankStatementsClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new UploadBankStatementsClicked(properties), options);
  }

  /**
   * VAT returns upload clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/VAT%20returns%20upload%20clicked)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param options Amplitude event options.
   */
  vatReturnsUploadClicked(
    options?: EventOptions,
  ) {
    return this.track(new VatReturnsUploadClicked(), options);
  }

  /**
   * VAT returns uploaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/VAT%20returns%20uploaded)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param options Amplitude event options.
   */
  vatReturnsUploaded(
    options?: EventOptions,
  ) {
    return this.track(new VatReturnsUploaded(), options);
  }

  /**
   * Viewed offers
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Viewed%20offers)
   *
   * This event tracks when a user views offers within the iwocaPay buyer journey
   *
   * @param properties The event's properties (e.g. choose_offer_page)
   * @param options Amplitude event options.
   */
  viewedOffers(
    properties: ViewedOffersProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewedOffers(properties), options);
  }

  /**
   * Xero bank statements connect started
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Xero%20bank%20statements%20connect%20started)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param options Amplitude event options.
   */
  xeroBankStatementsConnectStarted(
    options?: EventOptions,
  ) {
    return this.track(new XeroBankStatementsConnectStarted(), options);
  }

  /**
   * Xero bank statements linked successfully
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Xero%20bank%20statements%20linked%20successfully)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param options Amplitude event options.
   */
  xeroBankStatementsLinkedSuccessfully(
    options?: EventOptions,
  ) {
    return this.track(new XeroBankStatementsLinkedSuccessfully(), options);
  }

  /**
   * Xero bank statements linking failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Xero%20bank%20statements%20linking%20failed)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param properties The event's properties (e.g. Error message)
   * @param options Amplitude event options.
   */
  xeroBankStatementsLinkingFailed(
    properties?: XeroBankStatementsLinkingFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new XeroBankStatementsLinkingFailed(properties), options);
  }

  /**
   * Xero bank statements modal opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Xero%20bank%20statements%20modal%20opened)
   *
   * Owner: Laurence Bernstein-Newman
   *
   * @param options Amplitude event options.
   */
  xeroBankStatementsModalOpened(
    options?: EventOptions,
  ) {
    return this.track(new XeroBankStatementsModalOpened(), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
